<template>
  <div style="width: 100%; height: 100%" class="df">
    <div style="flex: 1; width: 0; height: 100%">
      <div ref="threeBox" class="three-container">
        <div v-if="loading" class="loading-overlay">加载中...</div>
        <div v-if="error" class="error-overlay">{{ error }}</div>
        <div class="window">
          <el-button type="primary" @click="reset">镜头回正</el-button>
          <el-button
            type="warning"
            @click="
              isExpand = !isExpand;
              handleResize();
            "
            >{{ isExpand ? "折叠列表" : "展开列表" }}</el-button
          >
        </div>
        <div
          class="model-title-overlay"
          :class="{ visible: showObjectTitle }"
          :style="{
            left: titlePosition.x + 'px',
            top: titlePosition.y + 'px',
          }"
        >
          {{ objectTitle }}
        </div>
      </div>
    </div>
    <div
      class="sensor-container"
      :style="`
        width: ${isExpand ? '380px !important' : '0px !important'};
        height: 100%;
        background-color: #b2cce1;
        padding: ${isExpand ? '0 10px' : '0'};
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: scroll;
      `"
      v-loading="sensorLoading"
    >
      <div style="padding: 0 0 50px; width: 100%; overflow: hidden">
        <div
          class="df aic sensor-box"
          v-for="(item, index) in sensorData"
          :key="index"
          @click="openSensorDailog(item)"
          style="width: 100%; box-sizing: border-box"
        >
          <div class="df index-box">
            <div class="df aic jcc index">
              {{ index + 1 }}
            </div>
            <div style="flex: 1; width: 0" class="df aic jcc">
              <img
                src="./images/online.png"
                alt=""
                style="height: 30px"
                v-if="true"
              />
              <img
                src="./images/outline.png"
                alt=""
                style="height: 30px"
                v-else
              />
            </div>
          </div>
          <div style="flex: 1; width: 0" class="df aic info-box">
            <div
              style="
                width: 100%;
                color: #000;
                text-align: right;
                line-height: 22px;
                padding-left: 10px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="item.name"
                placement="left"
              >
                <span>
                  {{ item.name }}
                </span>
              </el-tooltip>
            </div>
            <div class="value df aic">
              {{ item.value }}
              <span
                style="
                  font-size: 16px;
                  font-wight: 700;
                  color: red;
                  line-height: 22px;
                "
              >
                {{ item.unit }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <el-dialog
      :title="videoTitle"
      :visible.sync="videoShow"
      @close="closeDialogAddgsVisible"
    >
      <div class="df aic" style="height: 30px; justify-content: flex-end">
        <el-button
          v-if="isRealTime"
          type="text"
          class="disib blue"
          size="mini"
          @click="handleReplyPics"
          >留影回看</el-button
        >
        <el-button
          v-else
          type="text"
          class="disib blue"
          size="mini"
          @click="isRealTime = true"
          >查看直播</el-button
        >
      </div>
      <div v-if="isRealTime">
        <live-video
          height="690"
          :autoplay="false"
          :id="videoUrl"
          :key="videoUrl"
          :companyId="companyId"
          :camId="videoId"
          :ref="'live-video-' + videoId"
        ></live-video>
      </div>
      <div v-else>
        <div>
          <el-date-picker
            v-model="timeValue"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            @change="handleTimeChange"
          >
          </el-date-picker>
        </div>
        <div style="margin-top: 10px" v-loading="picLoading">
          <el-image
            :src="imageSrc"
            :preview-src-list="[imageSrc]"
            style="width: 100%"
          >
          </el-image>
        </div>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6" style="text-align: center">
            <el-button size="mini" @click="handlePre">上一张</el-button>
          </el-col>

          <el-col :span="6" style="text-align: center">
            <el-button size="mini" @click="handleNext">下一张</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog> -->
    <VideoDialog
      :visible="videoDialog.visible"
      :title="videoDialog.title"
      :companyId="companyId"
      :camId="videoDialog.camId"
      mode="both"
      :videoUrl="videoDialog.videoUrl"
      @update:visible="videoDialog.visible = $event"
      @close="videoDialog.visible = false"
    />

    <SensorPopup
      :title="title"
      :sensor-id="checkedSensorId"
      :visible="dialogTableVisible"
      @update:visible="dialogTableVisible = $event"
      @close="handlePopupClose"
      @titleChange="titleChange"
    ></SensorPopup>
    <el-dialog :title="title" :visible.sync="showNullDailog">
      <div style="height: 200px; font-size: 30px" class="df aic jcc">
        <i class="el-icon-warning"></i>暂未上传数据
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as THREE from "three";
import LiveVideo from "./components/LiveVideo";
import axios from "../../../util/api";
import dayjs from "dayjs";
import api from "../../../util/extra-api";
import { pickerOptions, seriesOption } from "../sensor_screen/optionData";
// DRACOLoader
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// import Stats from "three/examples/jsm/libs/stats.module.js";

import SensorPopup from "../../../components/sensorCharts/SensorPopup.vue";
import VideoDialog from "../../../components/VideoDialog.vue";

export default {
  components: {
    // LiveVideo,
    SensorPopup,
    VideoDialog,
  },
  data() {
    let temperatureModel =
      "https://shelldisk.esunadv.com/models/%E4%BC%A0%E6%84%9F%E5%99%A8.STL";
    let humidityModel =
      "https://shelldisk.esunadv.com/models/%E4%BC%A0%E6%84%9F%E5%99%A8.STL";
    let cam1Model = "https://shelldisk.esunadv.com/models/cam1.STL";
    let camModel = "https://shelldisk.esunadv.com/models/cam.STL";

    // let GLTFModel = "https://shelldisk.esunadv.com/models/model.gltf";

    this.lineChartExtend = {
      "xAxis.0.axisLabel.rotate": 45,
    };
    this.lineChartSettings = {
      labelMap: {
        time: "时间",
        value: "值",
      },
    };
    return {
      videoDialog: {
        visible: false,
        title: "",
        camId: null,
        videoUrl: "",
      },
      checkedSensorId: "",
      showCharts: true,
      isExpand: true,
      showNullDailog: false,
      buttonFlag: false,
      pickerOptions,
      seriesOption,
      sensorLoading: false,
      companyId: 2582338,
      camera: null,
      scene: null,
      renderer: null,
      frameId: null,
      raycaster: null,
      mouse: null,
      controls: null,
      modelGroup: null,
      // stats: null,
      loading: true,
      error: null,
      hoveredObject: null, // 当前悬停的对象
      needsRender: true, // 按需渲染标志
      resizeTimeout: null, // 窗口调整防抖
      modelList: [],
      gridTableData: [],
      showObjectTitle: false,
      objectTitle: "",
      titlePosition: { x: 0, y: 0 },
      unit: "",
      list: [
        {
          id: 0,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E5%A4%96%E5%A2%992.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0xeeeeee,
          x: -4.75,
          y: 1,
          z: 0,
          scale: 0.1,
          interactive: false,
          transparent: true,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 0,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E5%A4%96%E5%A2%994.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0xeeeeee,
          x: 115.8,
          y: 1,
          z: 0,
          scale: 0.1,
          interactive: false,
          transparent: true,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 1,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E5%BA%95%E9%83%A81.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0xeeeeee,
          x: 0,
          y: 0,
          z: 0,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 1,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E5%BA%95%E9%83%A88.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0xeeeeee,
          x: 100.8,
          y: 0,
          z: 0,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },

        {
          id: 2,
          linkIds: [3],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E5%8A%A0%E6%96%99%E4%BC%A0%E9%80%81%E5%B8%A6-1.STL",
          modelName: "top-box-13",
          deviceType: "device",
          materialColor: 0xb2cce1,
          x: -18.65,
          y: 1,
          z: -16.2,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 3,
          linkIds: [2],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E5%8A%A0%E6%96%99%E4%BC%A0%E9%80%81%E5%B8%A6-2.STL",
          modelName: "top-box-13",
          deviceType: "device",
          materialColor: 0xb2cce1,
          x: -18.65,
          y: 6.8,
          z: -19.2883,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 4,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E5%9F%BA%E7%A1%80%E4%BC%A0%E9%80%81%E5%B8%A62.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0x139ba2,
          x: -20.45,
          y: 1,
          z: 40,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 90,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 5,
          linkIds: [6],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95.STL",
          modelName: "成品罐体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: -36.25,
          y: 1,
          z: -49,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 337 });
          },
        },
        {
          id: 6,
          linkIds: [5],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95%E6%A1%B6.STL",
          modelName: "成品罐体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: -36.87,
          y: 1.01,
          z: -49.34,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 337 });
          },
        },
        {
          id: 29,
          linkIds: [30],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95.STL",
          modelName: "混合罐体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: -36.25,
          y: 1,
          z: -57,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 336 });
          },
        },
        {
          id: 30,
          linkIds: [29],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95%E6%A1%B6.STL",
          modelName: "混合罐体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: -36.87,
          y: 1.01,
          z: -57.34,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 336 });
          },
        },
        {
          id: 51,
          linkIds: [52],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95.STL",
          modelName: "TEUP机原油罐2体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: 90.62,
          y: 0.95,
          z: -57,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 335 });
          },
        },
        {
          id: 52,
          linkIds: [51],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95%E6%A1%B6.STL",
          modelName: "TEUP机原油罐2体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: 90,
          y: 0.97,
          z: -57.34,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 335 });
          },
        },
        {
          id: 53,
          linkIds: [54],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95.STL",
          modelName: "TEUP机原油罐1体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: 100.62,
          y: 0.95,
          z: -57,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 334 });
          },
        },
        {
          id: 54,
          linkIds: [53],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E7%BD%90%E5%AD%90-%E5%8D%95%E6%A1%B6.STL",
          modelName: "TEUP机原油罐1体积",
          deviceType: "device",
          materialColor: 0xff6600,
          x: 100,
          y: 0.97,
          z: -57.34,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 334 });
          },
        },
        {
          id: 7,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E9%95%BF%E4%BC%A0%E9%80%81%E5%B8%A61.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0x3a5779,
          x: -25.85,
          y: 1,
          z: 7.9,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 8,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E8%BE%93%E6%B2%B9%E7%AE%A1%E9%81%931.STL",
          modelName: "top-box-1",
          deviceType: "device",
          materialColor: 0x5c9f59,
          x: -27.45,
          y: 1,
          z: -42.2,
          scale: 0.1,
          interactive: false,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 9,
          linkIds: [10],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%99%E6%96%97-%E6%8F%8F%E8%BE%B9.STL",
          modelName: "全萃料实时称重",
          deviceType: "device",
          materialColor: 0xcc0001,
          x: -27.6,
          y: 1,
          z: -63,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 332 });
          },
        },
        {
          id: 10,
          linkIds: [9],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%99%E6%96%97-%E6%97%A0%E6%8F%8F%E8%BE%B9.STL",
          modelName: "全萃料实时称重",
          deviceType: "device",
          materialColor: 0xcc0001,
          x: -27.6,
          y: 1,
          z: -63,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 332 });
          },
        },
        {
          id: 11,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/TEUP.STL",
          modelName: "TEUP机沉料高度",
          deviceType: "device",
          materialColor: 0xb8d1d0,
          x: -3.22,
          y: 1,
          z: -63,
          scale: 0.1,
          interactive: true,
          transparent: false,
          opacity: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          showEdge: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 331 });
          },
        },
        {
          id: 12,
          linkIds: [13],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E8%AE%BE%E5%A4%87-1.STL",
          modelName: "传送带",
          materialColor: 0x4e5180,
          x: -0.05,
          y: 1,
          z: 3.5,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 13,
          linkIds: [12],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%96%B0%E6%AF%94%E4%BE%8B%E8%AE%BE%E5%A4%87-2.STL",
          modelName: "传送带",
          materialColor: 0x6d7876,
          x: -1.25,
          y: 1,
          z: 3.5,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 14,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q 自立袋包装灌装区",
          materialColor: 0xffc985,
          x: -25,
          y: 26,
          z: -32.3,
          scale: 0.3,
          rotationX: 0,
          rotationY: 90,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 296
            this.openCam(296, e.userData.modelName, "31011500991320254731");
          },
        },
        {
          id: 15,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q TEUP控制操作区",
          materialColor: 0xffc985,
          x: -23.5,
          y: 26,
          z: -36.45,
          scale: 0.3,
          rotationX: 0,
          rotationY: -90,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 302
            this.openCam(303, e.userData.modelName, "31011500991320254729");
          },
        },
        {
          id: 16,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q 外包装智能机械手操作区",
          materialColor: 0xffc985,
          x: -25,
          y: 26,
          z: 37.95,
          scale: 0.3,
          rotationX: 0,
          rotationY: 90,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 305
            this.openCam(300, e.userData.modelName, "31011500991320254722");
          },
        },
        {
          id: 17,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q 粉料自动灌装及自立袋输入段",
          materialColor: 0xffc985,
          x: -23.5,
          y: 26,
          z: 33.75,
          scale: 0.3,
          rotationX: 0,
          rotationY: -90,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 301
            this.openCam(301, e.userData.modelName, "31011500991320254727");
          },
        },
        {
          id: 17,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q 粉料混合区",
          materialColor: 0xffc985,
          x: 10,
          y: 26,
          z: 33.75,
          scale: 0.3,
          rotationX: 0,
          rotationY: -90,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 298
            this.openCam(298, e.userData.modelName, "31011500991320254724");
          },
        },
        {
          id: 18,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q 精滤区",
          materialColor: 0xffc985,
          x: -25,
          y: 26,
          z: -67.5,
          scale: 0.3,
          rotationX: 0,
          rotationY: 90,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 293
            this.openCam(293, e.userData.modelName, "31011500991320254719");
          },
        },
        {
          id: 19,
          linkIds: [],
          type: "STL",
          url: camModel,
          modelName: "Q TEUP进料区",
          materialColor: 0xffc985,
          x: 34.35,
          y: 26,
          z: -69,
          scale: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 297
            this.openCam(297, e.userData.modelName, "31011500991320254723");
          },
        },
        {
          id: 20,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "外包机械手自动装箱区",
          materialColor: 0xa7b7ca,
          x: -38.1,
          y: 26,
          z: 67,
          scale: 0.3,
          rotationX: 0,
          rotationY: 180,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 300
            this.openCam(300, e.userData.modelName, "31011500991320254726");
          },
        },
        {
          id: 21,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "粉料自动灌装落袋区",
          materialColor: 0xa7b7ca,
          x: -38.1,
          y: 26,
          z: 6,
          scale: 0.3,
          rotationX: 0,
          rotationY: 180,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 299
            this.openCam(299, e.userData.modelName, "31011500991320254725");
          },
        },
        {
          id: 22,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "自立袋包装穿杆/落袋区",
          materialColor: 0xa7b7ca,
          x: -38.1,
          y: 26,
          z: -3,
          scale: 0.3,
          rotationX: 0,
          rotationY: 180,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 295
            this.openCam(295, e.userData.modelName, "31011500991320254721");
          },
        },
        {
          id: 23,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "库房四门",
          materialColor: 0xa7b7ca,
          x: 42.45,
          y: 26,
          z: 67,
          scale: 0.3,
          rotationX: 0,
          rotationY: 180,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openCam(294, e.userData.modelName, "31011500991320254720");
          },
        },

        {
          id: 55,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "车间四门",
          materialColor: 0xa7b7ca,
          x: 73.2,
          y: 26,
          z: -67,
          scale: 0.3,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openCam(304, e.userData.modelName, "31011500991320254730");
          },
        },
        {
          id: 26,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "正门/生产物资库入口",
          materialColor: 0xa7b7ca,
          x: 42.45,
          y: 26,
          z: -43.13,
          scale: 0.3,
          rotationX: 0,
          rotationY: 180,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 291
            this.openCam(291, e.userData.modelName, "31011500991320254717");
          },
        },
        {
          id: 27,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "TEUP机房",
          materialColor: 0xa7b7ca,
          x: 10,
          y: 18,
          z: -60,
          scale: 0.3,
          rotationX: 0,
          rotationY: 270,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 292
            this.openCam(292, e.userData.modelName, "31011500991320254718");
          },
        },
        {
          id: 28,
          linkIds: [],
          type: "STL",
          url: cam1Model,
          modelName: "初加工操作区",
          materialColor: 0xa7b7ca,
          x: 10,
          y: 26,
          z: -39.1,
          scale: 0.3,
          rotationX: 0,
          rotationY: 270,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // 302
            this.openCam(302, e.userData.modelName, "31011500991320254728");
          },
        },
        {
          id: 24,
          linkIds: [25],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%8A%AC%E5%8D%871.STL",
          modelName: "抬升机",
          materialColor: 0xa2ac86,
          x: 35.5,
          y: 0,
          z: -63.5,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 25,
          linkIds: [24],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%8A%AC%E5%8D%872.STL",
          modelName: "抬升机",
          materialColor: 0xa2ac86,
          x: 29.5,
          y: 1,
          z: -60,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: false,
          opacity: 0.5,
          interactive: false,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            console.log("e", e);
          },
        },
        {
          id: 31,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "混合间温度",
          materialColor: 0xff0000,
          x: 10,
          y: 25,
          z: 34.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 305 });
          },
        },
        {
          id: 57,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%8E%A5%E6%B6%B2%E6%A7%BD1.STL",
          modelName: "喂料槽实时称重",
          materialColor: 0xfce2c4,
          x: 0,
          y: 17,
          z: -68,
          scale: 0.05,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 321 });
          },
        },
        {
          id: 32,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "混合间湿度",
          materialColor: 0x47a0d2,
          x: 13,
          y: 25,
          z: 34.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 306 });
          },
        },
        {
          id: 33,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "固体自动化包装间温度",
          materialColor: 0xff0000,
          x: -13,
          y: 25,
          z: 34.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 303 });
          },
        },
        {
          id: 43,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "成品库温度",
          materialColor: 0xff0000,
          x: 83,
          y: 25,
          z: 35.8,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 314 });
          },
        },
        {
          id: 44,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "成品库湿度",
          materialColor: 0x47a0d2,
          x: 86,
          y: 25,
          z: 35.8,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 308 });
          },
        },
        {
          id: 45,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "原辅料及包材库温度",
          materialColor: 0xff0000,
          x: 83,
          y: 25,
          z: 0.65,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 306 });
          },
        },
        {
          id: 46,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "原辅料及包材库湿度",
          materialColor: 0x47a0d2,
          x: 86,
          y: 25,
          z: 0.65,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 309 });
          },
        },
        {
          id: 47,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "原料冷藏库温度",
          materialColor: 0xff0000,
          x: 83,
          y: 25,
          z: -1,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 310 });
          },
        },
        {
          id: 48,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "原料冷藏库湿度",
          materialColor: 0x47a0d2,
          x: 86,
          y: 25,
          z: -1,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 311 });
          },
        },
        {
          id: 49,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: " 生产配套物资库温度",
          materialColor: 0xff0000,
          x: 83,
          y: 25,
          z: -69.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            // this.openSensorDailog({ id: 312 });
            this.title = `历史数据[生产配套物资库温度]`;
            this.showNullDailog = true;
          },
        },
        {
          id: 50,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: " 生产配套物资库湿度",
          materialColor: 0x47a0d2,
          x: 86,
          y: 25,
          z: -69.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            // this.openSensorDailog({ id: 313 });
            is.title = `历史数据[生产配套物资库湿度]`;
            this.showNullDailog = true;
          },
        },
        {
          id: 34,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "固体自动化包装间湿度",
          materialColor: 0x47a0d2,
          x: -10,
          y: 25,
          z: 34.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 304 });
          },
        },
        {
          id: 35,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "液化自动化内包装间温度",
          materialColor: 0xff0000,
          x: -13,
          y: 25,
          z: -34.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 301 });
          },
        },
        {
          id: 36,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "液化自动化内包装间湿度",
          materialColor: 0x47a0d2,
          x: -10,
          y: 25,
          z: -34.4,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 302 });
          },
        },
        {
          id: 37,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "初加工车间温度",
          materialColor: 0xff0000,
          x: -44.2,
          y: 25,
          z: -52,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 299 });
          },
        },
        {
          id: 38,
          linkIds: [],
          type: "STL",
          url: humidityModel,
          modelName: "初加工车间湿度",
          materialColor: 0x47a0d2,
          x: -44.2,
          y: 25,
          z: -55,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 300 });
          },
        },
        {
          id: 39,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E8%BD%A61.STL",
          modelName: "TEUP机油车实高",
          materialColor: 0x47a0d2,
          x: 20,
          y: 2,
          z: -54,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 338 });
          },
        },
        {
          id: 40,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "油瞬时流量",
          materialColor: 0xd6e1c2,
          x: 9.8,
          y: 8,
          z: -58,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 340 });
          },
        },
        {
          id: 58,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "油总流量",
          materialColor: 0xffde02,
          x: 9.8,
          y: 10.2,
          z: -58,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 342 });
          },
        },
        {
          id: 41,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "水瞬时流量",
          materialColor: 0xd6e1c2,
          x: 9.8,
          y: 8,
          z: -68,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 339 });
          },
        },
        {
          id: 59,
          linkIds: [],
          type: "STL",
          url: temperatureModel,
          modelName: "水总流量",
          materialColor: 0xffde02,
          x: 9.8,
          y: 10.2,
          z: -68,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            // console.log("e", e);
            this.openSensorDailog({ id: 341 });
          },
        },
        {
          id: 56,
          linkIds: [],
          type: "STL",
          url: "https://shelldisk.esunadv.com/models/%E6%8E%A5%E6%B6%B2%E6%A7%BD1.STL",
          modelName: "泵液槽车",
          materialColor: 0xd6e1c2,
          x: -13,
          y: 2.1,
          z: -52,
          scale: 0.1,
          rotationX: 0,
          rotationY: 0,
          rotationZ: 0,
          transparent: false,
          showEdge: true,
          opacity: 0.5,
          interactive: true,
          err: "加载失败，请检查网络连接是否正常。",
          handleClick: (e) => {
            this.openSensorDailog({ id: 320 });
          },
          //
        },
      ],
      camId: null,
      videoId: null,
      videoShow: false,
      videoTitle: "",
      videoUrl: "",
      isRealTime: true,
      picLoading: false,
      timeValue: "",
      imageSrc: "",
      sensorData: [],
      sensorLoading1: false,
      lineChartFlag: false,
      lineChartLoading: false,
      gridData: [],
      hisQuery: {
        id: null,
        page: 1,
        companyId: 2582269,
        limit: 50,
        startTime: "",
        endTime: "",
      },
      pageFlag: false,
      lineChartData: {},
      total: 0,
      dateRange: "",
      title: null,
      dialogTableVisible: false,
      chartsLoading: false,
    };
  },
  mounted() {
    this.initializeThree();
    this.getSensorData();
  },
  beforeDestroy() {
    this.cleanupResources();
  },
  watch: {
    "lineChartData.rows"(v) {
      this.$nextTick((_) => {
        this.$refs[`lineChart`].echarts.resize();
      });
    },
    dialogTableVisible(v) {
      if (!v) {
        this.hisQuery.startTime = "";
        this.hisQuery.endTime = "";
        this.hisQuery.page = 1;
      }
    },
    videoShow(v) {
      if (!v) {
        this.imageSrc = "";
        this.isRealTime = true;
      }
    },
  },
  methods: {
    handlePopupClose() {
      this.dialogTableVisible = false;
    },
    handleLoadMore() {
      // console.log("触底加载更多数据...");
      this.handleCurrentChange(this.hisQuery.page + 1);
    },
    handleCurrentChange(val) {
      this.hisQuery.page = val;
      this.sensorLoading1 = true;
      api.get("/v1/wx/device/sensorHisData", this.hisQuery).then((response) => {
        const data = response.data;
        if (this.hisQuery.page == 1) {
          this.gridData = [];
        }
        this.gridTableData = data.data.map((m) => {
          return {
            data: m.value + m.unit,
            time: m.timeDate,
          };
        });
        this.gridData = this.gridData.concat(
          data.data.map((m) => {
            return {
              data: m.value,
              // dataString: m.value + m.unit,
              time: m.timeDate,
            };
          })
        );
        // console.log(this.hisQuery.page, this.gridData.length);

        if (data.data && data.data.length > 0) {
          this.unit = data.data[0].unit;
        } else {
          this.unit = "";
        }

        this.sensorLoading1 = false;
        this.total = data.total;
        this.pageFlag = true;
        this.dialogTableVisible = true;
      });
    },
    changeShowCharts() {
      this.showCharts = !this.showCharts;
      this.onSearch(1);
    },
    onSearch(value) {
      // console.log(value, "value");
      if (!value) {
        this.hisQuery.startTime = "";
        this.hisQuery.endTime = "";
      } else {
        this.hisQuery.startTime = this.dateRange[0];
        this.hisQuery.endTime = this.dateRange[1];
      }
      this.sensorLoading1 = true;
      this.hisQuery.page = 1;
      this.pageFlag = true;
      this.buttonFlag = true;
      api.get("/v1/wx/device/sensorHisData", this.hisQuery).then((response) => {
        const data = response.data;
        this.gridTableData = data.data.map((m) => {
          return {
            data: m.value + m.unit,
            time: m.timeDate,
          };
        });
        this.gridData = data.data.map((m) => {
          return {
            data: m.value,
            time: m.timeDate,
          };
        });
        this.total = data.total;
        this.sensorLoading1 = false;
      });
      // if (this.dateRange && this.dateRange.length > 0) {
      // } else {
      //   this.$message({
      //     message: "请先选择时间区间",
      //     type: "warning",
      //   });
      // }
    },
    onChangeChart() {
      this.lineChartFlag = !this.lineChartFlag;

      if (this.lineChartFlag) {
        this.lineChartLoading = true;
        api
          .get("/v1/wx/device/sensorHisData", this.hisQuery)
          .then((response) => {
            const data = response.data.data;
            this.lineChartData = {
              columns: ["timeDate", "value"],
              rows: data,
            };
            this.lineChartLoading = false;
          });
      }
    },
    openSensorDailog(item) {
      // if (!this.sensorData || !this.sensorData.length) {
      //   this.$message({
      //     message: "传感器数据加载中，请稍后",
      //     type: "warning",
      //   });
      //   return;
      // } else {
      this.checkedSensorId = item.id;

      this.hisQuery.id = item.id;
      this.dateRange = [];
      this.buttonFlag = false;
      this.sensorLoading1 = true;
      this.lineChartData = {};
      this.lineChartFlag = false;
      if (this.sensorData.length) {
        const name = this.sensorData.filter((v) => v.id === item.id)[0].name;
        this.title = `历史数据[${name}]`;
      } else {
        this.title = "";
      }
      this.hisQuery.id = item.id;
      this.chartsLoading = true;
      this.dialogTableVisible = true;
      // }
    },
    titleChange(name) {
      this.title = `历史数据[${name}]`;
    },
    getSensorData() {
      this.sensorLoading = true;
      api.get(`/v1/wx/device/fsSensorChart?companyId=2582338`).then((res) => {
        // let sortArr1 = [252, 245, 246, 248, 253, 244, 249, 251, 250];
        let sortArr = [
          299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 314,
          320, 321, 331, 332, 334, 335, 336, 337, 338, 339, 340, 341, 342,
        ];
        // 312, 313,
        this.sensorData = res.data
          .filter((v) => sortArr.includes(v.id))
          .sort((a, b) => sortArr.indexOf(a.id) - sortArr.indexOf(b.id));
        this.sensorLoading = false;
      });
    },
    handleTimeChange(time) {
      this.picLoading = true;
      axios
        .get("/pc/company-cam/camImg", {
          camId: this.camId,
          time: this.timeValue,
        })
        .then((response) => {
          this.imageSrc = response.data;
          this.picLoading = false;
        });
    },
    handlePre() {
      this.picLoading = true;
      this.timeValue = dayjs(this.timeValue)
        .subtract(1, "minute")
        .format("YYYY-MM-DD HH:mm");
      axios
        .get("/pc/company-cam/camImg", {
          camId: this.camId,
          time: this.timeValue,
        })
        .then((response) => {
          this.imageSrc = response.data;
          this.picLoading = false;
        });
    },
    handleNext() {
      this.picLoading = true;
      this.timeValue = dayjs(this.timeValue)
        .add(1, "minute")
        .format("YYYY-MM-DD HH:mm");
      axios
        .get("/pc/company-cam/camImg", {
          camId: this.camId,
          time: this.timeValue,
        })
        .then((response) => {
          this.imageSrc = response.data;
          this.picLoading = false;
        });
    },
    closeDialogAddgsVisible() {
      this.dialogAddgsVisible = false;
    },
    openCam(id, name, url) {
      this.videoDialog = {
        visible: true,
        title: name,
        camId: id,
        videoUrl: "https://qvs-live.esunadv.com:447/esunhttps/" + url + ".m3u8",
      };
      // this.videoId = id;
      // this.camId = id;
      // this.isRealTime = true;
      // this.videoShow = true;
      // this.videoTitle = name;
      // this.videoUrl =
      //   "https://qvs-live.esunadv.com:447/esunhttps/" + url + ".m3u8";
    },
    handleReplyPics() {
      this.isRealTime = false;
      this.timeValue = dayjs().format("YYYY-MM-DD HH:mm");
      this.picLoading = true;
      axios
        .get("/pc/company-cam/camImg", {
          camId: this.camId,
          time: this.timeValue,
        })
        .then((response) => {
          this.imageSrc = response.data;
          this.picLoading = false;
        });
    },
    fitCameraToScene() {
      const bbox = new THREE.Box3().setFromObject(this.modelGroup);
      const center = bbox.getCenter(new THREE.Vector3());
      const size = bbox.getSize(new THREE.Vector3());
      const maxSize = Math.max(size.x, size.y, size.z);

      this.camera.position.copy(center);
      this.camera.position.z += maxSize * 2.5; // 动态计算距离
      this.camera.lookAt(center);
      this.controls.target.copy(center);
      this.camera.zoom = 0.2;
      this.camera.position.x = this.camera.position.z * 1;
      this.camera.position.y = this.camera.position.z * 1.8;
      this.camera.position.z = 0;
      this.camera.updateProjectionMatrix();
      this.controls.update();
    },
    addEdges(mesh, geometry) {
      const edgesGeometry = new THREE.EdgesGeometry(geometry);
      const edgesMaterial = new THREE.LineBasicMaterial({
        color: 0x000000,
        linewidth: 2,
      });
      const edges = new THREE.LineSegments(edgesGeometry, edgesMaterial);
      edges.renderOrder = 1; // 确保边线在模型之上渲染
      mesh.add(edges);
    },
    initializeThree() {
      try {
        this.setupRenderer();
        this.setupSceneAndCamera();
        this.setupControls();
        this.setupLights();
        // this.setupStats();
        this.addEventListeners();
        this.loadModels();
        this.animate();
      } catch (error) {
        console.error("Three.js初始化失败:", error);
        this.error = "3D引擎初始化失败";
        this.loading = false;
      }
    },

    setupRenderer() {
      const container = this.$refs.threeBox;
      const width = container.clientWidth;
      const height = container.clientHeight;

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        logarithmicDepthBuffer: true,
        alpha: true,
        powerPreference: "high-performance",
      });
      this.renderer.setPixelRatio(window.devicePixelRatio || 1);
      this.renderer.setSize(width, height);
      this.renderer.setClearColor(0x000000);
      container.appendChild(this.renderer.domElement);
      // 添加触摸事件处理 - 关键修复
      this.setupTouchEvents();
    },

    setupTouchEvents() {
      const canvas = this.renderer.domElement;

      // 设置触摸行为
      canvas.style.touchAction = "none";

      // 阻止触摸事件的默认行为
      const preventDefault = (e) => {
        e.preventDefault();
      };

      // 添加触摸事件监听器
      canvas.addEventListener("touchstart", preventDefault, { passive: false });
      canvas.addEventListener("touchmove", preventDefault, { passive: false });
      canvas.addEventListener("touchend", preventDefault, { passive: false });

      // 确保触摸事件能够正确传递到OrbitControls
      canvas.addEventListener("touchstart", (e) => {
        if (this.controls) {
          this.controls.handleTouchStart(e);
        }
      });

      canvas.addEventListener("touchmove", (e) => {
        if (this.controls) {
          this.controls.handleTouchMove(e);
        }
      });

      canvas.addEventListener("touchend", (e) => {
        if (this.controls) {
          this.controls.handleTouchEnd(e);
        }
      });
    },

    setupSceneAndCamera() {
      const container = this.$refs.threeBox;
      const width = container.clientWidth;
      const height = container.clientHeight;
      const aspect = width / height;
      const viewSize = 10;

      this.scene = new THREE.Scene();
      this.camera = new THREE.OrthographicCamera(
        -viewSize * aspect,
        viewSize * aspect,
        viewSize,
        -viewSize,
        0.1,
        2000
      );
      this.camera.position.set(0, 400, 1000);
      this.camera.lookAt(0, 0, 0);

      this.modelGroup = new THREE.Group();
      this.scene.add(this.modelGroup);

      this.raycaster = new THREE.Raycaster();
      this.mouse = new THREE.Vector2();
    },

    setupControls() {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.maxPolarAngle = THREE.MathUtils.degToRad(80);
      this.controls.enableDamping = true;
      this.controls.minZoom = 0.1; // 最小缩放距离
      this.controls.maxZoom = 1.5; // 最大缩放距离
      this.controls.dampingFactor = 0.05; // 阻尼系数
      // this.controls.maxDistance = 200;
      // this.controls.maxDistance = maxDistance;

      // 确保触摸控制启用
      this.controls.enableTouch = true;
      this.controls.touches = {
        ONE: THREE.TOUCH.ROTATE,
        TWO: THREE.TOUCH.DOLLY_PAN,
      };

      // 控制器变化时标记需要渲染
      this.controls.addEventListener("change", () => {
        this.needsRender = true;
        this.scene.updateMatrixWorld(true);
      });
    },

    setupLights() {
      // 环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
      this.scene.add(ambientLight);

      // 方向光
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(10, 10, 5);
      directionalLight.castShadow = true;
      this.scene.add(directionalLight);
    },

    // setupStats() {
    //   this.stats = new Stats();
    //   this.$refs.threeBox.appendChild(this.stats.dom);
    // },

    addEventListeners() {
      const canvas = this.renderer.domElement;

      // 点击事件
      canvas.addEventListener("click", this.handleClick);

      // 鼠标移动事件（用于悬停效果）
      canvas.addEventListener("mousemove", this.handleMouseMove);

      // 鼠标离开画布
      canvas.addEventListener("mouseleave", this.handleMouseLeave);

      // 窗口调整
      window.addEventListener("resize", this.handleResize);

      // 阻止右键菜单
      canvas.addEventListener("contextmenu", this.preventDefault);
    },

    loadModels() {
      this.list.forEach((obj, index) => {
        this.loadModelFetch(obj, this.list.length);
      });
    },
    computeBoundingBox(geometry) {
      geometry.computeBoundingBox();
      const box = geometry.boundingBox;
      const width = box.max.x - box.min.x;
      const height = box.max.y - box.min.y;
      const depth = box.max.z - box.min.z;
      return { width, height, depth };
    },
    loadModelFetch(obj, modelLength) {
      if (!obj.type || !obj.url) {
        this.error = `模型配置错误: 缺少类型或URL`;
        this.loading = false;
        return;
      }

      let loader = null;
      if (obj.type === "STL") {
        loader = new STLLoader();
      } else if (obj.type === "GLTF") {
        loader = new DRACOLoader();
      } else {
        this.error = `不支持的模型类型: ${obj.type}`;
        this.loading = false;
        return;
      }

      loader.setCrossOrigin("anonymous");
      const loadTimeout = setTimeout(() => {
        loader.abort();
        this.error = `${obj.modelName} 加载超时`;
        this.loading = false;
      }, 30000);
      if (obj.type === "STL") {
        loader.load(
          obj.url,
          (gltf) => {
            clearTimeout(loadTimeout);
            try {
              if (obj.type === "STL") {
                const geometry = gltf;
                const material = new THREE.MeshPhongMaterial({
                  color: obj.materialColor,
                  emissive: 0x072534,
                  transparent: obj.transparent,
                  opacity: obj.opacity,
                  side: THREE.DoubleSide,
                  flatShading: true,
                });

                const model = new THREE.Mesh(geometry, material);
                model.userData = {
                  modelName: obj.modelName,
                  isModel: true,
                  interactive: obj.interactive,
                  id: obj.id,
                  linkIds: obj.linkIds,
                  // originalEmissive: 0x072534 // 初始发光色
                };

                const { width, height, depth } =
                  this.computeBoundingBox(geometry);
                const scaledWidth = width * obj.scale;
                const scaledDepth = depth * obj.scale;

                model.position.set(
                  obj.x - scaledWidth / 2,
                  obj.y,
                  obj.z - scaledDepth / 2
                );
                model.scale.set(obj.scale, obj.scale, obj.scale);
                model.rotation.set(
                  (obj.rotationX * Math.PI) / 180,
                  (obj.rotationY * Math.PI) / 180,
                  (obj.rotationZ * Math.PI) / 180
                );

                model.handleClick = obj.handleClick;

                this.modelList.push(model);
                this.modelGroup.add(model);
                if (obj.showEdge) {
                  this.addEdges(model, geometry);
                }
              } else if (obj.type === "GLTF") {
                // GLTF处理逻辑
              }
              this.checkLoadingComplete(modelLength);
            } catch (error) {
              console.error("模型处理失败:", error);
              this.error = `模型处理失败: ${error.message}`;
              this.loading = false;
            }
          },
          (xhr) => {
            // 加载进度处理
          },
          (error) => {
            clearTimeout(loadTimeout);
            console.error(obj.err, error);
            this.error = obj.err;

            if (error.message) {
              this.error += `: ${error.message}`;
            }
            if (error instanceof ErrorEvent) {
              this.error += ` (网络错误)`;
            } else if (error.status === 404) {
              this.error += ` (文件未找到)`;
            } else if (error.status === 403) {
              this.error += ` (访问被拒绝)`;
            }
            this.loading = false;
          }
        );
      } else if (obj.type === "GLTF") {
      }
    },

    checkLoadingComplete(modelLength) {
      if (this.modelList.length === modelLength) {
        this.loading = false;
        this.needsRender = true;
        this.fitCameraToScene();
      }
    },

    handleClick(event) {
      const rect = this.renderer.domElement.getBoundingClientRect();
      this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      // 确保场景矩阵最新
      this.scene.updateMatrixWorld(true);

      this.raycaster.setFromCamera(this.mouse, this.camera);
      const intersects = this.raycaster.intersectObjects(
        this.modelGroup.children,
        true
      );

      if (intersects.length > 0) {
        let clickedObject = intersects[0].object;

        // 向上遍历父级直到找到模型标记
        while (clickedObject && !clickedObject.userData.isModel) {
          clickedObject = clickedObject.parent;
        }

        // 确认找到了有效模型
        if (
          clickedObject &&
          clickedObject.userData.modelName &&
          clickedObject.userData.interactive
        ) {
          this.showObjectTitle = false;
          this.objectTitle = "";
          clickedObject.handleClick(clickedObject);
        }
        // else {
        //   console.warn("点击的对象不是模型或不可交互");
        // }
      }
    },

    // 鼠标移动事件处理（悬停效果）
    handleMouseMove(event) {
      this.updateMousePosition(event);
      this.updateTitlePosition(event);

      const hoveredObject = this.findHoveredObject();

      if (hoveredObject && hoveredObject.userData.interactive) {
        this.handleInteractiveHover(hoveredObject);
      } else {
        this.resetHoverState();
      }
    },

    updateMousePosition(event) {
      const rect = this.renderer.domElement.getBoundingClientRect();
      this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
    },

    updateTitlePosition(event) {
      const rect = this.renderer.domElement.getBoundingClientRect();
      this.titlePosition = {
        x: event.clientX - rect.left - 80,
        y: event.clientY - rect.top - 80,
      };
    },

    findHoveredObject() {
      this.scene.updateMatrixWorld(true);
      this.raycaster.setFromCamera(this.mouse, this.camera);
      const intersects = this.raycaster.intersectObjects(
        this.modelGroup.children,
        true
      );

      if (intersects.length === 0) return null;

      let hoveredObject = intersects[0].object;
      while (hoveredObject && !hoveredObject.userData?.isModel) {
        hoveredObject = hoveredObject.parent;
      }
      return hoveredObject;
    },
    getLinkModels(id) {
      return this.modelGroup.children.filter((v) =>
        v.userData.linkIds.includes(id)
      );
    },
    handleInteractiveHover(hoveredObject) {
      if (this.hoveredObject === hoveredObject) return;

      this.resetHoverState();

      if (hoveredObject.material) {
        hoveredObject.userData.originalEmissive =
          hoveredObject.material.emissive.getHex();
        hoveredObject.material.emissive.setHex(0xd2cce5);
        let linkModels = this.getLinkModels(hoveredObject.userData.id);
        linkModels.forEach((v) => {
          v.userData.originalEmissive = v.material.emissive.getHex();
          v.material.emissive.setHex(0xd2cce5);
        });
      }

      this.objectTitle = hoveredObject.userData.modelName || "";
      this.showObjectTitle = true;
      this.renderer.domElement.style.cursor = "pointer";
      this.hoveredObject = hoveredObject;
      this.needsRender = true;
    },

    resetHoverState() {
      if (!this.hoveredObject) return;

      if (
        this.hoveredObject.material &&
        this.hoveredObject.userData?.originalEmissive
      ) {
        this.hoveredObject.material.emissive.setHex(
          this.hoveredObject.userData.originalEmissive
        );
        let linkModels = this.getLinkModels(this.hoveredObject.userData.id);
        linkModels.forEach((v) => {
          v.material.emissive.setHex(v.userData.originalEmissive);
        });
      }

      this.hoveredObject = null;
      this.showObjectTitle = false;
      this.objectTitle = "";
      this.renderer.domElement.style.cursor = "default";
      this.needsRender = true;
    },

    // 鼠标离开画布时处理
    handleMouseLeave() {
      if (this.hoveredObject && this.hoveredObject.userData.interactive) {
        // 恢复悬停对象的原始样式
        this.hoveredObject.material.emissive.setHex(
          this.hoveredObject.userData.originalEmissive
        );
        let linkModels = this.getLinkModels(this.hoveredObject.userData.id);
        linkModels.forEach((v) => {
          v.material.emissive.setHex(v.userData.originalEmissive);
        });
        this.hoveredObject = null;
      }

      // 恢复默认鼠标指针
      this.renderer.domElement.style.cursor = "default";
      this.needsRender = true;
    },

    reset() {
      this.fitCameraToScene();
    },

    preventDefault(event) {
      event.preventDefault();
    },

    handleResize() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        if (!this.renderer || !this.camera) return;

        const container = this.$refs.threeBox;
        const width = container.clientWidth;
        const height = container.clientHeight;

        this.renderer.setSize(width, height);

        const aspect = width / height;
        const viewSize = 10;

        this.camera.left = -viewSize * aspect;
        this.camera.right = viewSize * aspect;
        this.camera.top = viewSize;
        this.camera.bottom = -viewSize;
        this.camera.updateProjectionMatrix();

        this.needsRender = true;
      }, 200);
    },

    animate() {
      // this.stats.update();
      this.frameId = requestAnimationFrame(this.animate);

      // 按需渲染;
      if (this.needsRender) {
        this.renderer.render(this.scene, this.camera);
        this.needsRender = false;
      }

      // 更新控制器
      if (this.controls) {
        this.controls.update();
      }
    },

    cleanupResources() {
      // 移除事件监听器
      const canvas = this.renderer?.domElement;
      if (canvas) {
        canvas.removeEventListener("click", this.handleClick);
        canvas.removeEventListener("mousemove", this.handleMouseMove);
        canvas.removeEventListener("mouseleave", this.handleMouseLeave);
        canvas.removeEventListener("contextmenu", this.preventDefault);
        if (canvas.parentNode) {
          canvas.parentNode.removeChild(canvas);
        }
      }
      window.removeEventListener("resize", this.handleResize);

      cancelAnimationFrame(this.frameId);

      if (this.controls) {
        this.controls.dispose();
        this.controls = null;
      }

      const disposeObject = (obj) => {
        if (obj.isMesh) {
          if (obj.geometry) obj.geometry.dispose();
          if (obj.material) {
            Array.isArray(obj.material)
              ? obj.material.forEach((m) => m.dispose())
              : obj.material.dispose();
          }
        }
      };

      if (this.modelGroup) {
        this.modelGroup.traverse(disposeObject);
        this.modelGroup = null;
      }

      if (this.scene) {
        this.scene.traverse(disposeObject);
        this.scene = null;
      }

      if (this.renderer) {
        this.renderer.dispose();
        this.renderer = null;
      }

      this.raycaster = null;
      this.mouse = null;
      this.camera = null;
    },
  },
};
</script>

<style scoped lang="scss">
.three-container {
  width: 100%;
  height: 100%;
  min-height: 300px;
  background: #f8f8f8;
  position: relative;
  overflow: hidden;
}

.three-container canvas {
  display: block;
  width: 100%;
  height: 100%;
  cursor: default; /* 默认鼠标样式 */
}

.window {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 100;
  background-color: transparent;
}

.loading-overlay,
.error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  font-size: 24px;
  pointer-events: none; /* 允许点击穿透 */
}

.error-overlay {
  color: red;
}

.model-title-overlay {
  position: absolute;
  z-index: 150;
  background: rgba(25, 25, 35, 0.85);
  pointer-events: none;
  backdrop-filter: blur(8px);
  border-radius: 12px;
  padding: 5px 15px;
  font-size: 1.2rem;
  font-weight: 500;
  color: #64b5f6;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(100, 181, 246, 0.3);
  max-width: 320px;
  text-align: center;
  transition: opacity 0.3s ease,
    transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  pointer-events: none;
  opacity: 0;
  transform: translateY(10px);
}

.model-title-overlay.visible {
  opacity: 1;
  transform: translateY(0);
}

.sensor-box:hover {
  cursor: pointer;
}
.sensor-box {
  height: 60px;
  box-sizing: border-box;
  padding: 15px;
  background-color: #fff;
  border-radius: 20px;
  margin: 10px 0;
  .index-box {
    width: 80px;
    height: 30px;
    border-radius: 10px;
    background-color: #eee;
    .index {
      background-color: #00baff;
      color: #fff;
      font-weight: 700;
      flex: 0 0 30px;
      border-radius: 10px;
    }
  }
  .info-box {
    justify-content: flex-end;
    .value {
      margin-left: 10px;
      justify-content: flex-end;
      font-size: 22px;
      font-weight: 700;
      color: #00baff;
    }
  }
}

.sensor-container {
  -ms-overflow-style: none;
  z-index: 9;
}
.sensor-container::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
}

.sensor-container::-webkit-scrollbar-thumb {
  border-radius: 5px;
  // background: rgba(255, 255, 255, 0.8);
  background: #fff;
  transition: color 0.2s ease;
  cursor: pointer;
}
</style>